"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Models behaviour as transitions between a finite set of states.
 *
 * @export
 * @class StateMachine
 * @template TState The type used to represent the states.
 * @template TTrigger The type used to represent the triggers that cause state transitions.
 */
var StateContext = /** @class */ (function () {
    function StateContext() {
    }
    return StateContext;
}());
exports.StateContext = StateContext;
